/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {MouseEventHandler} from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {FloatingIconButtonGroup} from '@ion/dls/src/components/buttons/FloatingIconButton';
import Tooltip from '@ion/dls/src/components/tooltip/Tooltip';
import {MaterialMoreVertIcon} from '@ion/dls/src/icons/MaterialMoreVertIcon';
import {IconSize} from '@ion/dls/src/types/types';

// Defines the props for the MoreIconTool component.
export type MoreMenuButtonProps = {
  size?: IconSize;
  isSelected?: boolean;
  shouldShowTooltip: boolean;
  onShowBottomSheet?: MouseEventHandler<HTMLButtonElement>;
};

/**
 * @MoreMenuButton
 * The MoreIcon component provides a simple Icon button that, when clicked,
 * initiates the Bottom sheet.
 *
 * import MoreMenuButton from '@ion/features/src/maps/tools/MoreMenuButton';
 *
 * ```typescript
 *
 *   <MoreMenuButton shouldShowTooltip={isPhone}
 *    onShowBottomSheet={onShowBottomSheet}
 *    isSelected={isSelected}
 *    size={size} />
 *
 * ```
 */
export const MoreMenuButton = ({
  size,
  isSelected,
  shouldShowTooltip,
  onShowBottomSheet
}: MoreMenuButtonProps) => {
  if (shouldShowTooltip) {
    return (
      <Tooltip title={translate('maps:controls.view')}>
        <div>
          <FloatingIconButtonGroup.FloatingIconButton onClick={onShowBottomSheet}
            isSelected={isSelected}>
            <MaterialMoreVertIcon size={size} />
          </FloatingIconButtonGroup.FloatingIconButton>
        </div>
      </Tooltip>
    );
  }
  return (
    <FloatingIconButtonGroup.FloatingIconButton onClick={onShowBottomSheet}
      isSelected={isSelected}>
      <MaterialMoreVertIcon size={size} />
    </FloatingIconButtonGroup.FloatingIconButton>
  );
};

export default MoreMenuButton;
